// JS que activa el sliders de listas de texto en modo listado. Ej. seccion los más nuevos HOME botones de opciones

$(document).ready(function(){
    // variables

    // acciones
    $('.js-slide-list').each( function (){
        slidelistContent($(this))
    })

    // funciones
    function slidelistContent(item) {
        $(`.js-slide-list__content-${item.data('slide-list__id')}`).slick({
            dots: false,
            arrow: false,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 7000,
            variableWidth: true
        })
    }

})